import { GqlModelInputTagFragment } from '../graphqlTypes'
import { ModelInputTag } from './model.types'

export function isValidModelInputTag(
  edge: GqlModelInputTagFragment | undefined | null,
): edge is ModelInputTag {
  return !!edge?.node
}
